// extracted by mini-css-extract-plugin
module.exports = {"root":"scrollbar_root__BW00r"};